import { create } from 'zustand'
import api from '@/shared/lib/api'

export interface User {
  id: string
  tenant_id: string
  email: string
  full_name: string | null
  role: string
  avatar_url: string | null
  provider: string
  email_verified: boolean
  onboarding_completed: boolean
}

interface AuthState {
  accessToken: string | null
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  setAccessToken: (token: string) => void
  setUser: (user: User) => void
  login: (token: string) => Promise<void>
  logout: () => void
  validateSession: () => Promise<boolean>
}

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: localStorage.getItem('access_token'),
  user: null,
  isAuthenticated: !!localStorage.getItem('access_token'),
  isLoading: true,

  setAccessToken: (token) => {
    localStorage.setItem('access_token', token)
    set({ accessToken: token, isAuthenticated: true })
  },

  setUser: (user) => set({ user }),

  login: async (token: string) => {
    localStorage.setItem('access_token', token)
    set({ accessToken: token, isAuthenticated: true })
    // Fetch user profile
    try {
      const { data } = await api.get('/auth/me')
      set({ user: data, isLoading: false })
    } catch {
      set({ isLoading: false })
    }
  },

  logout: () => {
    localStorage.removeItem('access_token')
    set({ accessToken: null, user: null, isAuthenticated: false, isLoading: false })
  },

  validateSession: async () => {
    const token = localStorage.getItem('access_token')
    if (!token) {
      set({ isAuthenticated: false, isLoading: false })
      return false
    }
    try {
      const { data } = await api.get('/auth/me')
      set({ user: data, isAuthenticated: true, isLoading: false })
      return true
    } catch {
      // Token invalid — clear everything
      localStorage.removeItem('access_token')
      set({ accessToken: null, user: null, isAuthenticated: false, isLoading: false })
      return false
    }
  },
}))
